import { render, staticRenderFns } from "./attributionForm.vue?vue&type=template&id=279f19b8&"
import script from "./attributionForm.vue?vue&type=script&lang=js&"
export * from "./attributionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports